import {useRef} from "react";
import * as React from "react";
import Content from "../domain/Content";
import OrganizationPlaceholder from "../domain/OrganizationPlaceholder";
import ViewInfo from "../domain/ViewInfo";
import NewsfeedItem from "./NewsfeedItem";
import CaughtUp from "./CaughtUp";

export interface INewsfeedProps {
    newsfeedViewInfo: ViewInfo;
    organizationPlaceholders: OrganizationPlaceholder[];
    organizationIcon?: string;
    onReadMore: (content: Content) => void;
    onDismiss: (content: Content) => void;
    onClickRefreshNewsfeed: () => void;
}
export default function Newsfeed (props: INewsfeedProps) {
    const currentPlaceholderIndex = useRef<number>(0);

    function getImage(content: Content) {
        let imageToUse: string = "";
        if (content && content.imageSrc && content.imageSrc.length > 0) {
            imageToUse = content.imageSrc;
        } else if (props.organizationPlaceholders && props.organizationPlaceholders.length > 0) {
            let targetIndex: number;
            const placeHolderLength: number = props.organizationPlaceholders.length;

            targetIndex = currentPlaceholderIndex.current;
            currentPlaceholderIndex.current++;
            if (currentPlaceholderIndex.current >= placeHolderLength) {
                currentPlaceholderIndex.current = 0;
            }

            imageToUse = props.organizationPlaceholders[targetIndex].imageSrc || "";

        }

        if (!imageToUse || imageToUse.length <= 0) {
            imageToUse = props.organizationIcon || "";
        }

        return imageToUse;
    }

    function render() {
        currentPlaceholderIndex.current = 0;
        const noActionItems: Content[] = props.newsfeedViewInfo.itemsToDisplay.filter((curItem: Content) => {
           return !curItem.isDismissed;
        });

        if (noActionItems.length > 0) {
            const items = noActionItems.map((curItem: Content) => {
                return (
                    <NewsfeedItem
                        content={curItem}
                        storyImage={getImage(curItem)}
                        key={"newsfeed" + curItem.postId}
                        onReadMore={ props.onReadMore }
                        onDismiss={ props.onDismiss  } />);
            });
            return (<React.Fragment>{items}</React.Fragment>);
        }else {
            return (<CaughtUp onClickRefreshNewsfeed={props.onClickRefreshNewsfeed} />);
        }

    }

    return render();
}
